"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _orionContext = require("../orionContext/orionContext");

var _constants = require("./constants");

var _pageAlert = _interopRequireDefault(require("./pageAlert"));

var _pageMain = _interopRequireDefault(require("./pageMain"));

var _pageHeader = _interopRequireDefault(require("./pageHeader"));

var _pageFooter = _interopRequireDefault(require("./pageFooter"));

var _pageTitle = _interopRequireDefault(require("./pageTitle"));

var _pageTitleText = _interopRequireDefault(require("./pageTitleText"));

var _pageActions = _interopRequireDefault(require("./pageActions"));

var _pageBody = _interopRequireDefault(require("./pageBody"));

var _pageTabs = _interopRequireDefault(require("./pageTabs"));

var _pageContext = _interopRequireDefault(require("./pageContext"));

require("./style.css");

require("./msp-provider.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OrionPage = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(OrionPage, _Component);

  var _super = _createSuper(OrionPage);

  function OrionPage(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, OrionPage);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideAlert", function () {
      _this.setState({
        showAlert: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setTabPresence", function (tabPresent) {
      _this.setState({
        tabPresent: tabPresent
      });
    });
    _this.state = {
      tabPresent: false,
      setTabPresence: _this.setTabPresence,
      showAlert: true
    };
    return _this;
  }

  (0, _createClass2["default"])(OrionPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.classList.add("oui-overflow-hidden");
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove("oui-overflow-hidden");
    }
  }, {
    key: "resolveComponents",
    value: function resolveComponents() {
      var _this2 = this;

      var sidebar = null;
      var main = null;
      var footer = null;
      var alert = null;
      var remaining = [];
      var children = this.props.children;
      (0, _forEach["default"])(_react.Children).call(_react.Children, children, function (child) {
        if ( /*#__PURE__*/(0, _react.isValidElement)(child)) {
          if (child.type.displayName === _constants.DISPLAY_NAME_SIDEBAR) {
            sidebar = child;
          } else if (child.type.displayName === _constants.DISPLAY_NAME_MAIN) {
            main = child;
          } else if (child.type.displayName === _constants.DISPLAY_NAME_FOOTER) {
            footer = child;
          } else if (child.type.displayName === _constants.DISPLAY_NAME_ALERT) {
            alert = /*#__PURE__*/(0, _react.cloneElement)(child, {
              className: (0, _utils.gatherClasses)(null, child.props.className, "oui-mb-0 oui-rounded-0"),
              onClose: child.props.onClose || _this2.hideAlert
            });
          } else {
            remaining.push(child);
          }
        } else {
          remaining.push(child);
        }
      });
      return {
        alert: alert,
        sidebar: sidebar,
        main: main,
        footer: footer,
        remaining: remaining
      };
    }
  }, {
    key: "render",
    value: function render() {
      var showAlert = this.state.showAlert;
      var _this$props = this.props,
          honourNavHeight = _this$props.honourNavHeight,
          leaveFooterSpace = _this$props.leaveFooterSpace,
          dataTestId = _this$props.dataTestId;

      var _this$resolveComponen = this.resolveComponents(),
          alert = _this$resolveComponen.alert,
          sidebar = _this$resolveComponen.sidebar,
          main = _this$resolveComponen.main,
          footer = _this$resolveComponen.footer,
          remaining = _this$resolveComponen.remaining;

      var _ref = this.context || {},
          dellDoubleHeader = _ref.dellDoubleHeader;

      return /*#__PURE__*/_react["default"].createElement(_pageContext["default"], {
        value: this.state
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": dataTestId,
        className: (0, _utils.gatherClasses)(this.props, "oui-page", dellDoubleHeader && "oui-double-header-support", honourNavHeight ? "oui-honour-nav-height" : "", footer !== null || leaveFooterSpace ? "oui-page-with-footer" : "", alert !== null && showAlert ? "oui-page-with-alert" : "")
      }, showAlert ? alert : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-d-flex"
      }, sidebar ? /*#__PURE__*/_react["default"].cloneElement(sidebar, {
        honourGlobalFooter: footer !== null || leaveFooterSpace,
        honourPageAlert: alert !== null && showAlert
      }) : null, main, remaining)), footer);
    }
  }]);
  return OrionPage;
}(_react.Component);

OrionPage.contextType = _orionContext.OrionContext;
OrionPage.defaultProps = {
  honourNavHeight: true,
  leaveFooterSpace: false,
  dataTestId: "orion-page"
};
OrionPage.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  honourNavHeight: _propTypes["default"].bool,
  leaveFooterSpace: _propTypes["default"].bool,
  dataTestId: _propTypes["default"].string
};
OrionPage.displayName = _constants.DISPLAY_NAME_PAGE;
OrionPage.Alert = _pageAlert["default"];
OrionPage.Main = _pageMain["default"];
OrionPage.Header = _pageHeader["default"];
OrionPage.Footer = _pageFooter["default"];
OrionPage.Title = _pageTitle["default"];
OrionPage.TitleText = _pageTitleText["default"];
OrionPage.Actions = _pageActions["default"];
OrionPage.Body = _pageBody["default"];
OrionPage.Tabs = _pageTabs["default"];
var _default = OrionPage;
exports["default"] = _default;